export default "__VITE_ASSET__kyMyLxOr__"